import Vue from "vue";
import Vuex from "vuex";
import accessPermission from "../../models/permisosDeAcceso/accessPermissions";
import segments from "../../models/horarios/segments";
import service from "../../services/permisosDeAcceso/accessPermissions";
import elements from "../../models/permisosDeAcceso/elements";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "300px",
    permissions: [],
    segments: [],
    permissionSegments: [],
    permissionId: null,
    elements: [],
    allDfis: [],
    dfis: [],
    elementId: null,
    segmentId: null,
    openSchedule: { type: "add", value: false },
    openSegment: { type: "tree", value: false },
    openElement: { type: "tree", value: false, itemId: null },
    openDfis: { type: "tree", value: false, itemId: null },
    newPermission: {},
    newSegment: {},
    itemDelete: null,
    openDeletePermission: false,
    openDeleteSeg: false,
    openDeleteEle: false,
    openDeleteDfis: false,
    mode: "Agregar horario",
    editPermission: {},
    sequence: [],
    editSegment: {},
    newElement: {},
    editElement: {},
    newDfis: {},
    editDfis: {},
    showElementWindow: false,
    showDfisWindow: false,
    showSegmentWindow: false,
    showScheduleWindow: false,
    showAssistentWindow: false,
    showHolidaysWindow: false,
    showEmployeesWindow: false,
    showGroupsWindow: false,
    newPermissionAsistent: {},
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setPermissions(state, data) {
      state.permissions = data;
    },
    setSegments(state, data) {
      state.segments = data;
    },
    setPermissionSegments(state, data) {
      state.permissionSegments = data;
    },
    setPermissionId(state, data) {
      state.permissionId = data;
    },
    setElements(state, data) {
      state.elements = data;
    },
    setDfis(state, data) {
      state.dfis = data;
    },
    setAllDfis(state, data) {
      state.allDfis = data;
    },
    setSegmentId(state, data) {
      state.segmentId = data;
    },
    setElementId(state, data) {
      state.elementId = data;
    },
    setOpenSchedule(state, data) {
      state.openSchedule = data;
    },
    setOpenSegment(state, data) {
      state.openSegment = data;
    },
    setOpenElement(state, data) {
      state.openElement = data;
    },
    setOpenDfis(state, data) {
      state.openDfis = data;
    },
    setNewPermission(state, data) {
      state.newPermission = data;
    },
    setNewSegment(state, data) {
      state.newSegment = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setOpenDeletePermission(state, data) {
      state.openDeletePermission = data;
    },
    setOpenDeleteSeg(state, data) {
      state.openDeleteSeg = data;
    },
    setOpenDeleteEle(state, data) {
      state.openDeleteEle = data;
    },
    setOpenDeleteDfis(state, data) {
      state.openDeleteDfis = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setEditItemPermission(state, data) {
      state.editPermission = data;
    },
    setSequence(state, data) {
      state.sequence = data;
    },
    setEditSegment(state, data) {
      state.editSegment = data;
    },
    setEditElement(state, data) {
      state.editElement = data;
    },
    setNewElement(state, data) {
      state.newElement = data;
    },
    setShowElementWindow(state, data) {
      state.showElementWindow = data;
    },
    setShowDfisWindow(state, data) {
      state.showDfisWindow = data;
    },
    setShowSegmentWindow(state, data) {
      state.showSegmentWindow = data;
    },
    setShowScheduleWindow(state, data) {
      state.showScheduleWindow = data;
    },
    setShowAssistentWindow(state, data) {
      state.showAssistentWindow = data;
    },
    setShowHolidaysWindow(state, data) {
      state.showHolidaysWindow = data;
    },
    setShowGroupsWindow(state, data) {
      state.showGroupsWindow = data;
    },
    setShowEmployeesWindow(state, data) {
      state.showEmployeesWindow = data;
    },
    setNewPermissionAsistent(state, data) {
      state.newPermissionAsistent = data;
    },
  },
  actions: {
    async getPermissions(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getAccessPermissions();
          state.commit("setPermissions", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getSegmentsPermissionId(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSegmentsPermissionId(
            state.state.permissionId
          );
          state.commit("setPermissionSegments", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getSegments(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSegments(
            state.state.permissionId
          );
          state.commit("setSegments", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getElements(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getElements(
            state.state.segmentId
          );
          state.commit("setElements", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getAllDfis(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getAllDfis();
          state.commit("setAllDfis", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getDfis(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getDFis(state.state.elementId);
          state.commit("setDfis", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async newPermission(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newAccessPermissions(state.state.newPermission)
            .then(({ data }) => {
              let item = data;
              let options = state.state.permissions;
              let newItem = accessPermission.fromJson({
                permisoId: item.permisoId,
                nombre: item.nombre,
                reqPin: item.reqPin,
                reqCacheo: item.reqCacheo,
                reqPassBack: item.reqPassBack,
                porcenCacheo: item.porcenCacheo,
                visita: item.visita,
                activo: item.activo,
              });
              options.push(newItem);
              state.commit("setPermissions", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async newAllPermissionAsistent(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newAllPermission(state.state.newPermissionAsistent)
            .then(({ data }) => {
              state.dispatch("getPermissions").then(() => {
                resolve(true);
              });
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async newSegment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newSegment(state.state.newSegment)
            .then(async () => {
              let item = await state.state.service.getSegments(
                state.state.permissionId
              );
              state.commit("setSegments", item);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async addElement(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newElementToSegment(state.state.newElement)
            .then(() => {
              let item = elements.fromJson(state.state.newElement);
              let options = state.state.elements;
              options.push(item);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async deletePermission(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteAccessPermissions(state.state.itemDelete.toString())
            .then(() => {
              let options = state.state.permissions;
              options = options.filter((option) => {
                return option.id != state.state.itemDelete;
              });
              state.commit("setPermissions", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteSegment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteSegments(state.state.itemDelete)
            .then(() => {
              let options = state.state.segments;
              options = options.filter((option) => {
                return option.id != state.state.itemDelete;
              });
              state.commit("setSegments", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteElement(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteElement(state.state.itemDelete)
            .then(() => {
              let options = state.state.elements;
              options = options.filter((option) => {
                return option.id != state.state.itemDelete;
              });
              state.commit("setElements", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editPermission(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editAccessPermissions(state.state.editPermission)
            .then(() => {
              let item = state.state.editPermission;
              let options = state.state.permissions;
              options = options.map((option) => {
                if (option.id !== item.id) {
                  return option;
                }
                item = accessPermission.fromJson({
                  permisoId: item.permisoId,
                  nombre: item.nombre,
                  reqPin: item.reqPin,
                  reqCacheo: reqCacheo,
                  reqPassBack: reqPassBack,
                  porcenCacheo: porcenCacheo,
                  visita: visita,
                  activo: item.activo,
                });
                return item;
              });

              state.commit("setSchedules", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editSegment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editSegment(state.state.editSegment)
            .then(async () => {
              let item = await state.state.service.getSegments(
                state.state.permissionId
              );
              state.commit("setSegments", item);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editElement(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editElement(state.state.editElement)
            .then(() => {
              let item = state.state.editElement;
              let options = state.state.elements;
              options = options.map((option) => {
                if (option.id !== item.id) {
                  return option;
                }
                let newItem = elements.fromJson({
                  permisoId: item.permisoId,
                  segmId: item.segmId,
                  elemId: item.id,
                  nombre: item.nombre,
                  desde: item.desde,
                  hasta: item.hasta,
                  aplNoFeriados: item.aplNoFeriados,
                  aplFeriados: item.aplFeriados,
                  reqPin: item.reqPin,
                  reqCacheo: item.reqCacheo,
                  reqPassBack: item.reqPassBack,
                  porcenCacheo: item.porcenCacheo,
                });
                return newItem;
              });
              state.commit("setElements", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async getSequence(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSequence(
            state.state.permissionId,
            state.state.segmentId
          );
          state.commit("setSequence", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async handleShowWindow(state, type) {
      return new Promise(async (resolve, reject) => {
        try {
          switch (type) {
            case "schedule":
              state.state.showScheduleWindow = true;
              state.state.showElementWindow = false;
              state.state.showDfisWindow = false;
              state.state.showSegmentWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showGroupsWindow = false;
              break;

            case "element":
              state.state.showElementWindow = true;
              state.state.showDfisWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showSegmentWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = false;
              break;

            case "dfis":
              state.state.showDfisWindow = true;
              state.state.showElementWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showSegmentWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = false;
              break;

            case "segment":
              state.state.showSegmentWindow = true;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showDfisWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = false;
              break;
            case "assistent":
              state.state.showSegmentWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showDfisWindow = false;
              state.state.showAssistentWindow = true;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = false;
              break;
            case "holiday":
              state.state.showSegmentWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showDfisWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = true;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = false;
              break;
            case "groups":
              state.state.showSegmentWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showDfisWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = true;
              break;
            case "employees":
              state.state.showSegmentWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showDfisWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = true;
              state.state.showGroupsWindow = false;
              break;
            default:
              break;
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
